import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import editIcon from '../../../images/icon-editing.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import { deleteUnit } from '../../../redux/slices/admin/unitsSlice';

const UnitsTable = ({ onEdit, handlePageChange }) => {
  const dispatch = useDispatch();
  const { units, currentUnitPage, totalUnitPages } = useSelector((state) => state.admin_units);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);


  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
      const toggleDropdown = (id, event) => {
        if (openDropdown === id) {
          setOpenDropdown(null);
        } else {
          const rect = event.target.getBoundingClientRect();
          setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
          setOpenDropdown(id);
        }
      };

        const handleDelete = (id) => {
    dispatch(deleteUnit(id));
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-toggle') && !event.target.closest('.dropdown-menu')) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

   const handleScroll = () => {
    setOpenDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <>
      <div className="table-responsive">
       <table className="table table-striped table-units table-alex printarea">
          <thead>
            <tr>
              <th>Name</th>
              <th>Creation Date</th>
              <th className="noprint">Actions</th>
            </tr>
          </thead>
          <tbody>
            {units.length > 0 ? (
              units.map((unit) => (
                <tr key={unit.id}>
                  <td>
                    <div className="text-start">{unit.unit_name}</div>
                  </td>
                  <td>
                    <div>{unit.creation_date}</div>
                  </td>
                  <td className="noprint">
                    <div className="text-center position-relative" ref={dropdownRef}>
                      <button
                        type="button"
                        className="bg-transparent border-0 p-0 btn-vert-dots"
                        aria-expanded={openDropdown === unit.id}
                        onClick={(e) => toggleDropdown(unit.id, e)}
                        aria-haspopup="true"
                      >
                        <img src={optionsIcon} alt="Options" />
                      </button>
                      {openDropdown === unit.id && (
                        <ul className="dropdown-menu dropdown-menu-end" 
                                                  style={{  display: 'block',
                                                        position: 'fixed',
                                                        top: `${dropdownPosition.top}px`,
                                                        left: `${dropdownPosition.left}px`,
                                                        width:`200px`,
                                                        zIndex: 1050, }}
                                                  >  
                          <li>
                            <a className="dropdown-item" onClick={() => onEdit(unit)}>
                              <img src={editIcon} alt="Edit" /> Edit
                            </a>
                          </li>

                          {localStorage.getItem("486478dh784dh4dh4d4h64nngx4c5v6bnyx7xnnvxsrdese") == "1" && (
                          <li>
                            <a className="dropdown-item" onClick={() => handleDelete(unit.id)}>
                              <img src={deleteIcon} alt="Delete" /> Delete
                            </a>
                          </li>
                          )}
                          
                        </ul>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center">No units found</td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
        <Pagination 
        currentPage={currentUnitPage} 
        totalPages={totalUnitPages} 
        onPageChange={handlePageChange} 
      />
    </>
  );
};

export default UnitsTable;